import styles from "./dateInput.module.css";

const DateInput = ({ value, setValue, className = "" }) => {
  const handleOnChange = (e) => {
    const date = e.target.value;
    setValue(date);
  };

  return (
    <input
      type="date"
      value={value}
      onChange={(e) => handleOnChange(e)}
      className={`${styles.dateInput} ${className}`}
    />
  );
};

export default DateInput;
